/**
 * CalendarEventPuff
 */
import clsx from 'clsx';
import React from 'react';
import { Image } from 'ui-component-library/base';
import { Link as LinkBase } from 'ui-component-library/base';
/** Main description for this component. */
var CalendarEventPuff = function (_a) {
    var src = _a.src, alt = _a.alt, heading = _a.heading, text = _a.text, eventDate = _a.eventDate, eventMonth = _a.eventMonth, category = _a.category, className = _a.className, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h3' : _b, url = _a.url, _c = _a.LinkComponent, LinkComponent = _c === void 0 ? LinkBase : _c;
    var Heading = headingLevel;
    var Link = LinkComponent;
    return (React.createElement("article", { "data-cid": "CalendarEventPuff", className: className },
        React.createElement(Link, { to: url, className: "group block" },
            React.createElement("div", { className: clsx(!src && 'h-52  mb-4', 'relative') },
                src && (React.createElement(Image, { loading: "lazy", src: src + '?height=208', alt: alt, className: "h-52 image__object-fit" })),
                eventDate && (React.createElement("span", { className: clsx('bg-primary-theme text-calendarEventPuff-text-color', 'text-4xl mb-10 -ml-3 px-3 absolute bottom-0 left-0') }, eventDate)),
                eventMonth && (React.createElement("span", { className: clsx('bg-primary-theme text-calendarEventPuff-text-color', 'text-h3 mb-3 -ml-3 px-3 absolute bottom-0 left-0') }, eventMonth))),
            React.createElement(Heading, { className: "mt-0 mb-1 text-h3 text-primary-2 font-fontWeightLink group-hover:underline" }, heading),
            category && (React.createElement("span", { className: "block text-p mb-1 text-greyDarker" }, category)),
            React.createElement("p", { className: "text-p text-black" }, text))));
};
export default CalendarEventPuff;
